export default class Locale_UnitTypeToggler {
	UnitTypeLockedWhenEditingWorkPackages: string = "Unittype is locked to hours when editing request templates in a multi unittype environment";
	UnitTypeIsLockedTo: string = "Unittype is locked to";
	CurrentlyViewingUnitTypeClickToChange: string = `Currently viewing '[[unittype]]', click to change unittype`
}